declare global {
  interface Window {
    __env__: any;
  }
}

// replaces useFlag from "@unleash/proxy-client-react" for using flags on build
export function useFlag(flagEnum: any): boolean {
  if (!window!.__env__!.REACT_APP_FEATURE_FLAGS) return false;
  return window.__env__.REACT_APP_FEATURE_FLAGS.indexOf(flagEnum) >= 0;
}
